import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { InitGuard } from '@root/modules/common/guard/init-guard';
import { LoginGuard } from '@root/modules/common/guard/login-guard';
import { HomePageComponent } from '@common/pages/home-page/home.page';
import { PaymentDisclaimerComponent } from '@common/components/payment-disclaimer/payment-disclaimer.component';

/**
 * Page Routing to be handled
 */

const routes: Routes = [
  {
    path : 'payment-disclaimer',
    component: PaymentDisclaimerComponent
  },
  {
    path: 'login',
    canActivate: [LoginGuard],
    loadChildren: () => import('./modules/login-registration/login-registration.module').then(m => m.LoginRegistrationModule)
  },
  {
    path: '',
    canActivate: [InitGuard],
    component: HomePageComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'investor-dashboard',
      },
      {
        path: 'investor-dashboard',
        loadChildren: () => import('@root/modules/investor-dashboard/investor-dashboard.module').then(m => m.InvestorDashboardPageModule)
      },
      {
        path: 'transact',
        loadChildren: () => import('@transactions/transactions.module').then(m => m.TransactionsPageModule)
      },
      {
        path: 'portfolio',
        loadChildren: () => import('@portfolio/portfolio.module').then(m => m.PortfolioModule)
      },
      {
        path: 'systematic-plans',
        loadChildren: () => import('@systematic-plans/systematic-plans.module').then(m => m.SystematicPlansModule)
      },
      {
        path: 'my-profile',
        loadChildren: () => import('@profile/profile.module').then(m => m.ProfilePageModule)
      },
      {
        path: 'link-delink-family-folio',
        loadChildren: () => import('@root/modules/link-delink-family-folio/link-delink-family-folio.module').then(m => m.LinkFamilyFolioPageModule)
      },
      {
        path: 'help',
        loadChildren: () => import('@root/modules/help/help.module').then(m => m.HelpPageModule)
      },
      {
        path: 'transaction-history',
        loadChildren: () => import('@transaction-history/transaction-history.module').then(m => m.TransactionHistoryModule)
      },
      {
        path: 'e-mandate',
        loadChildren: () => import('@e-mandate/e-mandate.module').then(m => m.EMandatePageModule)
      },
      {
        path: 'statements',
        loadChildren: () => import('@statements/statements.module').then(m => m.StatementsModule)
      },
      {
        path: 'new-investor',
        loadChildren: () => import('@new-investor/new-investor.module').then(m => m.NewInvestorModule)
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes,
      {
        preloadingStrategy: PreloadAllModules,
        useHash: true,
        scrollPositionRestoration: 'enabled',
        relativeLinkResolution: 'legacy'

      }
    )
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
